/* ==========================================================================
   KOTT Parallax — scroll-driven gentle vertical motion, modelled after the
   shopify-stats parallax effect.

   Mark an element with [data-kparallax="0.06"] (number = speed multiplier).
   The element translates vertically based on its OWNING section's distance
   from the viewport center:

     translateY = (section.center - viewport.center) * speed * -1

   So when the section is perfectly centered there is no translation; as the
   section scrolls up or down past the centre, the elements drift in opposite
   directions to that scroll, giving a parallax feel.

   The actual movement is applied via the CSS `translate` property (not
   `transform`), which composes cleanly with `transform` used for hovers,
   scale-reveal animations, etc. Modern browsers (Chrome 104+, Safari 14.1+,
   Firefox 72+) support `translate` — anything older just sees the element
   in its resting position, no harm done.

   The owning section is the element's closest `<section>` ancestor, or the
   element marked `[data-kparallax-root]` if explicitly set. If none, we use
   the element itself as the rectangle reference.

   Honors prefers-reduced-motion (the script no-ops entirely).
   ========================================================================== */
(function () {
  'use strict';

  if (window.kottReduceMotion ? window.kottReduceMotion() : window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var items = [];
  var rafQueued = false;

  function findRoot(el) {
    return (
      el.closest('[data-kparallax-root]') ||
      el.closest('section') ||
      el.closest('[data-section-type]') ||
      el.parentElement ||
      el
    );
  }

  function register(el) {
    var speed = parseFloat(el.getAttribute('data-kparallax')) || 0.06;
    var root = findRoot(el);
    var item = { el: el, root: root, speed: speed, visible: false };
    items.push(item);

    // Only update items whose root is on-screen — avoids work for hidden sections.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        item.visible = entry.isIntersecting;
        if (entry.isIntersecting) request();
      });
    }, { rootMargin: '50% 0px 50% 0px' });
    io.observe(root);
  }

  function update() {
    rafQueued = false;
    var viewH = window.innerHeight;
    var viewCenter = viewH / 2;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item.visible) continue;
      var rect = item.root.getBoundingClientRect();
      var rootCenter = rect.top + rect.height / 2;
      var offset = (rootCenter - viewCenter) * item.speed * -1;
      item.el.style.setProperty('--kparallax-y', offset.toFixed(2) + 'px');
    }
  }

  function request() {
    if (rafQueued) return;
    rafQueued = true;
    requestAnimationFrame(update);
  }

  function init() {
    var els = document.querySelectorAll('[data-kparallax]');
    Array.prototype.forEach.call(els, register);
    if (!items.length) return;
    update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-editor reload support
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(
      e.target.querySelectorAll('[data-kparallax]'),
      register
    );
    update();
  });
})();
